/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "icon" | "full" | "text";
}

export function Logo({ className, size = "md", variant = "full" }: LogoProps) {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const textSizes = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-base",
    xl: "text-lg",
  };

  const Icon = () => (
    <svg
      viewBox="0 0 48 48"
      className={cn("fill-current", sizeClasses[size])}
      aria-hidden="true"
    >
      {/* Hard Hat */}
      <path d="M12 20c0-6.627 5.373-12 12-12s12 5.373 12 12v2h-2v-2c0-5.514-4.486-10-10-10s-10 4.486-10 10v2h-2v-2z" />
      <path d="M10 22h28v2c0 2.209-1.791 4-4 4H14c-2.209 0-4-1.791-4-4v-2z" />
      <path d="M14 24h20v2c0 1.105-.895 2-2 2H16c-1.105 0-2-.895-2-2v-2z" />

      {/* Blueprint */}
      <path d="M8 32h32v8c0 1.105-.895 2-2 2H10c-1.105 0-2-.895-2-2v-8z" />
      <path d="M12 36h24v2c0 .552-.448 1-1 1H13c-.552 0-1-.448-1-1v-2z" />
      <path d="M12 40h16v2c0 .552-.448 1-1 1H13c-.552 0-1-.448-1-1v-2z" />

      {/* Blueprint lines */}
      <path d="M16 34h8v1h-8z" />
      <path d="M28 34h4v1h-4z" />
      <path d="M16 38h12v1h-12z" />
    </svg>
  );

  if (variant === "icon") {
    return <Icon />;
  }

  if (variant === "text") {
    return (
      <span className={cn("font-bold text-foreground", textSizes[size])}>
        CONTRACTOR CO-PILOT
      </span>
    );
  }

  return (
    <div className={cn("flex items-center space-x-3", className)}>
      <div className="text-primary">
        <Icon />
      </div>
      <span className={cn("font-bold text-foreground", textSizes[size])}>
        CONTRACTOR CO-PILOT
      </span>
    </div>
  );
}
